import React, { useRef, useState, useEffect, useContext } from "react";
import * as S from "./FlorenzSearchInput.style.js";
import ZaiaImage from "../../zaiaComponents/zaiaImage";
import { ThemeContext } from 'styled-components';
import useRecordNavigation from "../../../hooks/useRecordNavigation.js";
import { Actions } from "../../../utils/actionsIds.js";
const defaultUserImg = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaImgDefault/default-user.png`;

function FlorenzSearchInput({ 
  placeholder,
  forWhiteBackgroud, 
  getText,
  borderanimation = true
}) {
  const theme = useContext(ThemeContext);

  const container = useRef(null);
  const textInput = useRef(null);
  const { recordAction } = useRecordNavigation();

  const [listActive, setlistActive] = useState(false)

  
  useEffect(() => {
    const handleClickOutside = e => {
      if (!container.current.contains(e.target)) {
        setlistActive(false)
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const focusInput = () => {
    textInput.current.focus();
    recordAction(Actions.AINAVIGATOR.SEARCH_PATIENT);    
  }

  const blurInput = () => {
  }

  return (
    <S.FlorenzSearchInput 
      onFocus={() => focusInput()}  
      onBlur={() => blurInput()}
      forWhiteBackgroud={forWhiteBackgroud}
      borderanimation={borderanimation}
    >
      <div className="zaia-input" ref={container}>
        <div className="zaia-input-container" onClick={(e) => setlistActive(e)}>
          <i className="icon-search icon zaia-icono-search" ></i>
          <input 
            ref={textInput} 
            placeholder={placeholder} 
            onChange={(event) => getText(event.target.value)}
          />
          { 
            textInput.current && textInput.current.value !== "" &&
            <div className="icon-search-delete"
              onClick={() => {
                getText("");
                textInput.current.value = "";
              }}
            >
              <i className="icon zaia-icono-cerrar" ></i>
            </div>
          }
        </div>
      </div>
    </S.FlorenzSearchInput>
  );
}

export default FlorenzSearchInput;
